module.exports = __webpack_public_path__ + "static/media/automation.5d873a52.png";